export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const handleValidation = (name, value) => {
    switch (name) {
        case 'email':
        case 'forgotEmail':
            if (!value || value.trim() === "") {
                return 'Email is required.'
            } else if (!value.toLowerCase().match(emailRegex)) {
                return 'Invalid email address.'
            } else return null
        case 'password':
            if (!value || value.trim() === "") {
                return 'Password is required.'
            } else if (value?.length < 8) {
                return 'Password must be minimum 8 characters.'
            } else return null
        case 'otp':
            if (!value || value.trim() === "") {
                return 'Google Authenticator Code is required.'
            } else if (value?.length < 6 || value?.length > 6) {
                return 'Invalid Google Authenticator Code. Please check you have entered the code from the correct entry in your Authenticator app, or contact the admin'
            } else return null
        default: return null
    }
}